import { Box, Typography, CircularProgress, Button } from "@mui/material";
import { useEffect, useState } from "react";
import axios from "../../utils/axiosInstance";
import { getPlgSDSPSetpointsBtn } from "../../utils/wellsConfig";
import { ProgressDialog } from "../plungerPage/progressPopup";

const CompressorItems = [
  {
    items: [
      {
        label: "System Voltage",
        liveValue: 12.3,
        unit: "V",
      },
      {
        label: "System Recycle Valve Closed",
        liveValue: 12.3,
        unit: "%",
      },
      {
        label: "Desired Speed Out",
        liveValue: 12.3,
        unit: "RPM",
      },
      {
        label: "Field Pressure",
        liveValue: 12.3,
        unit: "PSI",
      },

      {
        label: "Suction Scrubber Pressure",
        liveValue: 12.3,
        unit: "PSI",
      },
      {
        label: "Interstage Pressure",
        liveValue: 12.3,
        unit: "PSI",
      },
      {
        label: "Discharge Pressure",
        liveValue: 12.3,
        unit: "PSI",
      },
      {
        label: "Compressor Oil Pressure",
        liveValue: 12.3,
        unit: "PSI",
      },
    ],
  },
];
const EngineItems = [
  {
    items: [
      {
        label: "Engine Speed",
        liveValue: 12.3,
        unit: "RPM",
      },
      {
        label: "Engine Oil Pressure",
        liveValue: 12.3,
        unit: "PSI",
      },

      {
        label: "Intake Mfld Pressure",
        liveValue: 12.3,
        unit: "Hg",
      },
      {
        label: "Engine Oil Temperature",
        liveValue: 12.3,
        unit: "F",
      },
      {
        label: "Coolant Temperature",
        liveValue: 12.3,
        unit: "F",
      },
    ],
  },
];
const CompRighttems = [
  {
    items: [
      {
        label: "Discharge 1 Temperature",
        liveValue: 12.3,
        unit: "F",
      },
      {
        label: "Discharge 2 Temperature",
        liveValue: 12.3,
        unit: "F",
      },
    ],
  },
];
const registers = [
  "_40179",
  "_40191",
  "_40190",
  "_40180",
  "_40197",
  "_40181",
  "_40196",
  "_40185",
  "_40178",
  "_40182",
  "_40184",
  "_40188",
  "_40189",
  "_40187",
  "_40186",
];

export default function FaultSnapshotsC5(selectedDevice) {
  const [loading, setLoading] = useState(true);
  const [CompressorData, setCompressorData] = useState(CompressorItems);
  const [EngineData, setEngineData] = useState(EngineItems);
  const [CompRightData, setCompRightData] = useState(CompRighttems);
  const [progressOpen, setProgressOpen] = useState(false);
  const [progressSuccess, setProgressSuccess] = useState(false);
  const [progressError, setProgressError] = useState("");
  const fetchData = async () => {
    try {
      setLoading(true);
      const [regResp, engResp] = await Promise.all([
        axios.post(
          `${process.env.REACT_APP_API_GATEAWAY}/iot/device_get_by_register/${selectedDevice.selectedDevice.device.id}`,
          registers,
        ),
        axios.get(
          `${process.env.REACT_APP_API_GATEAWAY}/iot/engine-data/${selectedDevice.selectedDevice.device.id}`,
        ),
      ]);

      const regData = regResp.data.data.response;
      const engData = engResp.data.response;

      const updatedCompressor = CompressorData.map((group) => ({
        ...group,
        items: group.items.map((it) => {
          let updatedLiveValue = it.liveValue;

          switch (it.label) {
            case "System Voltage":
              updatedLiveValue = regData["_40179"].toFixed(2) / 10;
              break;
            case "System Recycle Valve Closed":
              updatedLiveValue = regData["_40191"].toFixed(2) / 100;
              break;
            case "Desired Speed Out":
              updatedLiveValue = regData["_40190"];
              break;
            case "Field Pressure":
              updatedLiveValue = regData["_40180"].toFixed(1) / 10;
              break;
            case "Suction Scrubber Pressure":
              updatedLiveValue = regData["_40197"].toFixed(1) / 10;
              break;
            case "Interstage Pressure":
              updatedLiveValue = regData["_40181"].toFixed(1) / 10;
              break;
            case "Discharge Pressure":
              updatedLiveValue = regData["_40196"].toFixed(1) / 10;
              break;
            case "Compressor Oil Pressure":
              updatedLiveValue = regData["_40185"].toFixed(1) / 10;
              break;
          }

          return {
            ...it,
            liveValue: updatedLiveValue,
          };
        }),
      }));
      setCompressorData(updatedCompressor);

      const updatedEngine = EngineData.map((group) => ({
        ...group,
        items: group.items.map((it) => {
          let updatedLiveValue = it.liveValue;

          switch (it.label) {
            case "Engine Speed":
              updatedLiveValue = regData["_40178"];
              break;
            case "Engine Oil Pressure":
              updatedLiveValue = regData["_40182"].toFixed(1) / 10;
              break;
            case "Intake Mfld Pressure":
              updatedLiveValue = regData["_40184"].toFixed(1) / 10;
              break;
            case "Engine Oil Temperature":
              updatedLiveValue = regData["_40188"];
              break;
            case "Coolant Temperature":
              updatedLiveValue = regData["_40189"];
              break;
          }

          return {
            ...it,
            liveValue: updatedLiveValue,
          };
        }),
      }));
      setEngineData(updatedEngine);

      const updatedCompRight = CompRightData.map((group) => ({
        ...group,
        items: group.items.map((it) => {
          let updatedLiveValue = it.liveValue;

          switch (it.label) {
            case "Discharge 1 Temperature":
              updatedLiveValue = regData["_40187"];
              break;
            case "Discharge 2 Temperature":
              updatedLiveValue = regData["_40186"];
              break;
          }

          return {
            ...it,
            liveValue: updatedLiveValue,
          };
        }),
      }));
      setCompRightData(updatedCompRight);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!selectedDevice.selectedDevice.device?.id) return;
    fetchData();
  }, [selectedDevice.selectedDevice.device?.id]);

  return (
    <Box sx={{ width: "100%", maxWidth: "100vw" }}>
      {/* HEADER */}
      <Box
        sx={{
          bgcolor: "#1e293b",
          px: 2,
          py: 1,
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography sx={{ color: "#ffffffff", fontSize: 14 }}>
          Fault Snapshots
        </Typography>
        <Box
          sx={{
            display: "flex",
            gap: 1,
            justifyContent: "flex-end",
            flexGrow: 1,
          }}
        >
          <Button
            color="primary"
            variant="contained"
            size="small"
            sx={{ fontSize: 12 }}
            onClick={() =>
              getPlgSDSPSetpointsBtn(
                selectedDevice.selectedDevice.device?.id,
                registers,
                "P,177,5,183,8,195,2",
                setProgressSuccess,
                setProgressError,
                setProgressOpen,
              )
            }
          >
            Get Setpoints
          </Button>
        </Box>
      </Box>

      {/* CONTENT */}
      {loading ? (
        <Box
          sx={{
            height: "300px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <CircularProgress />
          <Typography sx={{ color: "#94a3b8", fontSize: 13 }}>
            Loading fault snapshots...
          </Typography>
        </Box>
      ) : (
        <Box sx={{ p: 2 }}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr", // mobile: single column
                sm: "1fr 1fr", // tablet: 2 columns
                md: "1fr 1fr", // desktop: 2 columns
              },
              gap: 2,
            }}
          >
            {/* LEFT COLUMN */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
              }}
            >
              {/* Compressor CARD */}
              <Box sx={{ bgcolor: "#1e293b", borderRadius: 2, p: 2 }}>
                <Typography sx={{ color: "white", mb: 1, fontWeight: "bold" }}>
                  Compressor Data
                </Typography>

                {CompressorData[0].items.map((item, i) => (
                  <Box
                    key={i}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      py: 0.5,
                      borderBottom: "1px solid #334155",
                    }}
                  >
                    <Typography sx={{ color: "#cbd5f5", fontSize: 13 }}>
                      {item.label}
                    </Typography>
                    <Typography sx={{ color: "#38bdf8", fontWeight: "bold" }}>
                      {item.liveValue} {item.unit}
                    </Typography>
                  </Box>
                ))}
              </Box>

              {/* ENGINE CARD */}
              <Box sx={{ bgcolor: "#1e293b", borderRadius: 2, p: 2 }}>
                <Typography sx={{ color: "white", mb: 1, fontWeight: "bold" }}>
                  Engine Data
                </Typography>

                {EngineData[0].items.map((item, i) => (
                  <Box
                    key={i}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      py: 0.5,
                      borderBottom: "1px solid #334155",
                    }}
                  >
                    <Typography sx={{ color: "#cbd5f5", fontSize: 13 }}>
                      {item.label}
                    </Typography>
                    <Typography sx={{ color: "#38bdf8", fontWeight: "bold" }}>
                      {item.liveValue} {item.unit}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>

            {/* RIGHT COLUMN */}
            <Box sx={{ bgcolor: "#1e293b", borderRadius: 2, p: 2 }}>
              <Typography sx={{ color: "white", mb: 1, fontWeight: "bold" }}>
                Compressor Data
              </Typography>

              {CompRightData[0].items.map((item, i) => (
                <Box
                  key={i}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    py: 0.5,
                    borderBottom: "1px solid #334155",
                  }}
                >
                  <Typography sx={{ color: "#cbd5f5", fontSize: 13 }}>
                    {item.label}
                  </Typography>
                  <Typography sx={{ color: "#38bdf8", fontWeight: "bold" }}>
                    {item.liveValue} {item.unit}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      )}
      <ProgressDialog
        open={progressOpen}
        isSuccess={progressSuccess}
        errorMessage={progressError}
        onClose={() => {
          setProgressOpen(false);
          setProgressError("");
        }}
        onRefresh={async () => {
          setProgressOpen(false);
          setProgressError("");
          await fetchData();
        }}
        loadingMessage="Check Device Response. Operation in-progress ..."
        successMessage="Successfully updated!"
      />
    </Box>
  );
}
